<div class="checklist-item-input">
	<div class="checkmark"></div>
	<input
		class="new-checklist-item-input"
		type="text"
		[formControl]="formControl"
		[placeholder]="'add_task' | translate"
		(keydown.enter)="submitNewItem()"
	/>
</div>
